const heading = "_35shf90dj";
const body = "_35sb1hu73xe";

export { body, heading };
import "./shared.modal.linaria.module.css";
//# sourceMappingURL=shared.modal.js.map
